import React from 'react';
import { Resource } from '../../../types';
import { useTranslation } from '../../../contexts/TranslationContext';

interface SimulationConfigurationFormProps {
  resource: Resource;
  onUpdate: (updates: Partial<Resource>) => void;
}

export const SimulationConfigurationForm: React.FC<SimulationConfigurationFormProps> = ({
  resource,
  onUpdate
}) => {
  const { t } = useTranslation();
  
  const updateResource = (field: string, value: any) => {
    onUpdate({ [field]: value });
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{t('resourceConfig.simulationTitle')}</label>
        <input
          type="text"
          value={resource.simulation_data?.title || t('resourceConfig.virtualLabSimulation')}
          onChange={(e) => {
            onUpdate({
              simulation_data: {
                ...resource.simulation_data,
                title: e.target.value
              }
            });
          }}
          className="input-field"
          placeholder={t('resourceConfig.enterSimulationTitle')}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{t('resourceConfig.description')}</label>
        <textarea
          value={resource.simulation_data?.description || ''}
          onChange={(e) => {
            onUpdate({
              simulation_data: {
                ...resource.simulation_data,
                description: e.target.value
              }
            });
          }}
          className="input-field"
          rows={3}
          placeholder={t('resourceConfig.enterSimulationDescription')}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{t('resourceConfig.interactive')}</label>
        <input
          type="checkbox"
          checked={resource.interactive !== false}
          onChange={(e) => updateResource('interactive', e.target.checked)}
          className="rounded border-gray-300"
        />
        <span className="ml-2 text-sm text-gray-600">{t('resourceConfig.allowUserInteraction')}</span>
      </div>
    </div>
  );
};
